import React from "react";
import { CardDeck, Card, Container, Row, Col } from 'react-bootstrap';
import MainMenu from '../../components/menu/MainMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faPhoneAlt  } from '@fortawesome/free-solid-svg-icons';
import Map from '../../resources/images/map.jpg';
import ContactUs from '../../resources/images/contact_us.jpg';
import './Contact.css';

const Contact =  (props) => {
    const {role} = props;
    return (
        <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu mainMenu={"contact"} subMenu={null} role={role}/>
                        {/* <Jumbotron fluid className="contact-background"/> */}
                        <Container>
                            <Row className="mt-5">
                                <Col className="pl-0">
                                    <h1 className='font-weight-bold text-scb page-title'>CONTACT US</h1>
                                </Col>
                            </Row>  
                            <Row className="mt-3">
                                <Col sm={9}>
                                    <CardDeck>
                                        <Card className="shadow">
                                            <Card.Img variant="top" src={ContactUs} />
                                            <Card.Body>
                                            <Card.Title className="font-weight-bold text-grey">
                                                <FontAwesomeIcon icon={faPhoneAlt} className="mr-2"/>
                                                SCB BUSINESS CALL CENTER
                                            </Card.Title>
                                            <Card.Text>
                                                <h1 className='text-scb font-weight-bold mb-1 mt-3 tel-number text-center'>
                                                    <a className='text-scb' href="tel:+662 722 2222">02 722 2222</a>
                                                </h1>
                                            </Card.Text>
                                            </Card.Body>
                                        </Card>
                                        <Card className="shadow">
                                            <Card.Img variant="top" src={Map} />
                                            <Card.Body>
                                            <Card.Title className="font-weight-bold text-grey">
                                                <FontAwesomeIcon icon={faBuilding} className="mr-2"/>
                                                SCB HEAD OFFICE
                                            </Card.Title>
                                            <Card.Text className="pl-4 ml-2">
                                                <p className='text-scb mb-1'>Siam Commercial Bank PCL.</p>
                                                <p className='text-scb mb-1'>9 Ratchadapisek Rd., Chatuchak</p>
                                                <p className='text-scb mb-1'>Bangkok 10900 Thailand</p>
                                            </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </CardDeck>
                                </Col>
                            </Row>
                        </Container>
                        
                    </Card.Body>
                </Card>
            </React.Fragment>
    );
}
export default Contact;